import SideBar from "components/our-services/SideBar";
import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Tab, Accordion } from "react-bootstrap";

const RemovalPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_10.title}</h2>
      <Tab.Container id="removal-services" defaultActiveKey="first">
        <Row>
          <Row>
            <Col>
              {lang.services.lists.list_10.paragraphs.map(l => <p>{l}</p>)}
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_10.accordion.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
              <p style={{ marginTop: "20px" }}>
                {lang.services.lists.list_10.why_us}
              </p>
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_10.accordion_why.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
              <p style={{ marginTop: "20px" }}>
                <span className="underlined-yellow">
                  {lang.services.lists.list_10.closing_paragraph_1}
                </span>{" "}
                {lang.services.lists.list_10.closing_paragraph_2}
              </p>
            </Col>
            <SideBar />
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default RemovalPage;
